import React from "react";
import classnames from "classnames";
// JavaScript library that creates a callendar with events
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interaction from "@fullcalendar/interaction";
// react component used to create sweet alerts
import ReactBSAlert from "react-bootstrap-sweetalert";
import InputMask from 'react-input-mask';
// reactstrap components
import {Alert,InputGroupText,InputGroupAddon,Button,ButtonGroup,Card,CardHeader,CardBody,FormGroup,Input,Modal,Row,Col,Container,InputGroup} from "reactstrap";
//import { events } from "variables/general.jsx";
import NotificationAlert from "react-notification-alert";
import { connect } from 'react-redux';
import api from "./../../Api.js";

import moment from "moment";
import $ from "jquery";

import reduxHelper from "./../../helper/index.js";

import ptbr from '@fullcalendar/core/locales/pt-br'; 
import en from '@fullcalendar/core/locales/en-gb'; 

//slet calendar;

class Calendar2 extends React.Component {

	constructor(props){

		super(props);
    this.state = {calendarError:"",editCalendar:"",events:[],alert:null,classroom:[],units:[],lessons:[],dialogCalendar:{},modalCalendar:false};
    this.postCalendar = this.postCalendar.bind(this);
    this.putCalendar = this.putCalendar.bind(this);
    this.changeClassRoom = this.changeClassRoom.bind(this);
    this.newCalendar = this.newCalendar.bind(this);
    this.resetCalendarDialog = this.resetCalendarDialog.bind(this);
    this.helper = new reduxHelper(this.props);
    this.refreshCalendar = this.refreshCalendar.bind(this);
    this.removeEvent = this.removeEvent.bind(this);
    this.generateDescription = this.generateDescription.bind(this);

    this.calendar = {};

    window.calendar = this;

  }
  

  //Para gerar uma descrição automaticamente
  generateDescription(){
    
    var dialogCalendar = this.state.dialogCalendar;
    dialogCalendar.description = $("#select_lesson").find(':selected').html();
    this.setState({dialogCalendar:dialogCalendar});

  }

  async componentDidMount(){

    await this.myclassroom();
    await this.getCalendar();
    await this.createCalendar();
    this.refreshCalendar();

  }
 
  componentDidUpdate(){  
    
    //Para mudar a linguagem na mesma hora
    if($('.fc-day-number').length !== 0){ 
      
      this.calendar.setOption('locale',this.props.user.preference.language); 
    
    } 
  
  }

  async filterEvent(obj){
      
    obj.allDay = true;
    obj.durationEditable = false;
    obj.className = obj.color;

    var d = obj.date.split('-');
    obj.start = new Date(parseInt(d[0]),parseInt(d[1]) - 1, parseInt(d[2]));
    obj.title = obj.description;

    if(obj.title === ""){ obj.title = obj.lesson_data.name; }

    obj.editable = false;

    return obj;

  }

  //Para pegar os calendarios
  async getCalendar(){

    await api.getCalendar().then(async (res) => {
    
      this.setState({events:res.data});

    }).catch(error => {

      console.log(error.data);
      console.log(error);
      console.log(error.response);
  
      if(error.response.status === 400){

        this.setState({calendarError:""});
        this.setState({calendarError:error.response.data.msg});

      }

    });

  }

  //Ao mudar o select da classroom
  async changeClassRoom(id){

    if(id === ""){

      await this.setState({units:[],lessons:[]});
      return false;

    }else{

      id = parseInt(id);
      console.log(id);

      var index = this.state.classroom.map(function(x) {return x.id; }).indexOf(id);
 
      var classroom = this.state.classroom[index];
      console.log(classroom);
      var course = classroom.course;

      var dialogCalendar = this.state.dialogCalendar;
      dialogCalendar.classroom = id;
      this.setState({dialogCalendar:dialogCalendar});

    }
 
    //Busco as units
    var units = await this.helper.unit().getUnitsCourse(course);

    //Se o servidor responder
    if(units !== false){

      //Caso consiga pegar...
      if(units.status === 200){ 

        await this.setState({units:units.data}); 
        if(units.data[0] !== undefined){ this.changeUnit(units.data[0].id); }

      }

      //Caso não...
      if(units.status === 400){ this.setState({calendarError:units.data.msg}); }

    }

  }

  //Ao mudar o select da unit
  async changeUnit(unit){

    //console.log('unit:'+unit);

    var dialogCalendar = this.state.dialogCalendar;
    dialogCalendar.unit = unit;
    await this.setState({dialogCalendar:dialogCalendar});

  
    var lessons = await this.helper.lesson().getLessonsUnit(unit);

   if(lessons !== false){

      //Caso consiga pegar...
      if(lessons.status === 200){ 

        //await this.setState({units:units.data}); 
        //if(units.data[0] !== undefined){ this.changeUnit(units.data[0].id); }
        await this.setState({lessons:lessons.data});

      }

      //Caso não...
      if(lessons.status === 400){ 

        await this.setState({calendarError:""});
        await this.setState({calendarError:lessons.data.msg});

      }

    }

  } 

  createCalendar(){

    this.calendar = new Calendar(this.refs.calendar, {
      plugins: [interaction, dayGridPlugin],
      defaultView: "dayGridMonth",
      locales: [ptbr,en],
      locale: this.props.user.preference.language,
      selectable: true,
      selectHelper: true,
      disableDragging:true,
      editable: true,
      events: [],
      // Add new event
      select: info => {

       // console.log(info);
        this.newCalendar(info);

      },
      // Edit calendar event action
      eventClick: async ({event})  =>  {

        //console.log(event);
        //console.log(event._def);
        //console.log(event._def.extendedProps);
        this.setState({calendarError:""});

        this.resetCalendarDialog();
        
        var dialogCalendar = this.state.dialogCalendar;

        dialogCalendar.classroom = event._def.extendedProps.classroom;
        dialogCalendar.lesson = event._def.extendedProps.lesson;
        dialogCalendar.description = event._def.extendedProps.description;
        dialogCalendar.color = event._def.ui.backgroundColor;
        
        dialogCalendar.date = moment(event.start,'YYYY-MM-DD').format('DD/MM/YYYY');
        dialogCalendar.time = moment(event._def.extendedProps.time,'HH:mm:ss').format('HH:mm'); 

        //busco a turma as units da turma
        await this.changeClassRoom(dialogCalendar.classroom);

        //pegos os daoos da lesson
        var lesson = await this.helper.lesson().getLesson(dialogCalendar.lesson);
        if(lesson.status === 200){

          dialogCalendar.unit = lesson.data.unit;
          await this.changeUnit(dialogCalendar.unit);
 
        }

        this.setState({calendarError:"",editCalendar:event.id,dialogCalendar:dialogCalendar,titleModalCalendar:this.props.translate['editar_evento'],buttonModalCalendar:this.props.translate['salvar_alteracoes']});

      }


    });

    this.calendar.render();
    this.setState({currentDate: this.calendar.view.title });

  };


  changeView = newView => {
    this.calendar.changeView(newView);
    this.setState({
      currentDate: this.calendar.view.title
    });
  };
 

  changeEvent = () => {

    var newEvents = this.state.events.map((prop, key) => {

      if (prop.id + "" === this.state.eventId + "") {
        
        this.state.event.remove();
        this.calendar.addEvent({...prop,title: this.state.eventTitle,className: this.state.radios,description: this.state.eventDescription});
        
        return {...prop, title: this.state.eventTitle, className: this.state.radios, description: this.state.eventDescription};

      }else{

        return prop;

      }

    });

    this.setState({
      modalChange: false,
      events: newEvents,
      radios: "bg-info",
      eventTitle: undefined,
      eventDescription: undefined,
      eventId: undefined,
      event: undefined
    });

  };

  deleteEventSweetAlert = () => {

    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Você tem certeza?"
          onConfirm={() => this.setState({alert:false,radios:"bg-info",eventTitle:undefined,eventDescription:undefined,eventId:undefined}) }
          onCancel={() => this.deleteEvent() }
          confirmBtnCssClass="btn-secondary"
          cancelBtnBsStyle="danger"
          confirmBtnText="Cancelar"
          cancelBtnText="Sim, pode remover"
          showCancel
          btnSize=""
        >
          Você não poderá reverter isso!
        </ReactBSAlert>
      )
    });

  };

  async deleteEvent(){

    var remove = await api.deleteCalendar(this.state.editCalendar).then(async (res) => {

      //console.log(res.data);
      return true;

    }).catch(error => {

      console.log(error.data);
      console.log(error);
      console.log(error.response);
  
      if(error.response.status === 400){

        let options = {place: "tr",message: (<div className="alert-text"><span className="alert-title" data-notify="title">{this.props.translate['ops']}!</span><span data-notify="message">{error.response.data.msg}</span></div>),type: 'danger',icon: "fas fa-exclamation",autoDismiss: 7};
        this.refs.notificationAlert.notificationAlert(options);

      }

      return false;

    });


    if(remove === false){ return false; }

    this.setState({
      alert: (
        <ReactBSAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Sucesso"
          onConfirm={() => this.setState({ alert: null })}
          onCancel={() => this.setState({ alert: null })}
          confirmBtnBsStyle="primary"
          confirmBtnText="Ok"
          btnSize="">
          {this.props.translate['o_evento_foi_removido']}
        </ReactBSAlert>
      ),
      modalChange: false,
      //events: newEvents,
      radios: "bg-info",
      eventTitle: undefined,
      eventDescription: undefined,
      eventId: undefined,
      event: undefined
    });

    await this.getCalendar();
    await this.refreshCalendar();
    this.setState({modalCalendar:false});

  };	
 
  //Para cadastrar um calendario novo
  async postCalendar(){

    var obj = JSON.parse(JSON.stringify(this.state.dialogCalendar));
    delete obj.unit;
    obj.time = obj.time+':00';

    obj.date = moment(obj.date,'DD/MM/YYYY').format('YYYY-MM-DD');
    obj.lesson = $("#select_lesson").val();

    await api.postCalendar(obj).then(async (res) => {

        this.setState({modalCalendar:false});
        let options = {place: "tr",message: (<div className="alert-text"><span className="alert-title" data-notify="title">O evento foi cadastrado com sucesso.</span></div>),type: 'success',icon: "ni ni-check-bold",autoDismiss: 7};
        this.refs.notificationAlert.notificationAlert(options);
       
        var events = this.state.events;
        events.push(res.data.event);
        await this.setState({events:events});
   
        this.refreshCalendar();

    }).catch(error => {

      console.log(error.data);
      console.log(error);
      console.log(error.response);
  
      if(error.response.status === 400){

        this.setState({calendarError:""});
        this.setState({calendarError:error.response.data.msg});

      }

    });

  }

  //Para atualizar o calendario
  async putCalendar(){

    var obj = JSON.parse(JSON.stringify(this.state.dialogCalendar));
    delete obj.unit;
    obj.time = obj.time+':00';

    obj.date = moment(obj.date,'DD/MM/YYYY').format('YYYY-MM-DD');
    obj.lesson = $("#select_lesson").val();

    await api.putCalendar(this.state.editCalendar,obj).then(async (res) => {

        this.setState({modalCalendar:false});
        let options = {place: "tr",message: (<div className="alert-text"><span className="alert-title" data-notify="title">As alterações foram salvas.</span></div>),type: 'success',icon: "ni ni-check-bold",autoDismiss: 7};
        this.refs.notificationAlert.notificationAlert(options);
       
        var events = this.state.events;
        for (let i = 0; i < events.length; i++) {
          
          if(parseInt(events[i].id) === parseInt(this.state.editCalendar)){

            events[i] = res.data.event;
            //console.log(res.data.event);

          }

        }
        
        await this.setState({events:events});
   
        this.refreshCalendar();

    }).catch(error => {

      console.log(error.data);
      console.log(error);
      console.log(error.response);
  
      if(error.response.status === 400){

        this.setState({calendarError:""});
        this.setState({calendarError:error.response.data.msg});

      }

    });

  }

  //Para recarregar todos os eventos no calendario
  async refreshCalendar(){

    await this.calendar.removeAllEvents();

    for (var i = 0; i < this.state.events.length; i++) {

      this.calendar.addEvent( await this.filterEvent(this.state.events[i]) );

    }

  }

  //Lista todas as turmas que eu tenho acesso
  //para buscar todos os usuarios via api
  async myclassroom(){

      await api.getMyClassRooms().then((res) => {

        //?this.setState({classRooms:res.data});
        //res.data.reverse();
        this.setState({classroom:res.data})

      }).catch(error => {

        console.log(error.data);
        console.log(error);
        console.log(error.response);

        if(error.response !== undefined){

          if(error.response.status !== undefined){

            if(error.response.status === 401){

              let options = {place: "tr",message: (<div className="alert-text"><span className="alert-title" data-notify="title">Ops!</span><span data-notify="message">{error.response.data.msg}</span></div>),type: 'danger',icon: "fas fa-exclamation",autoDismiss: 7};
              this.refs.notificationAlert.notificationAlert(options);

            }

          }

        }

      });
    
  }

  //editCalendar(){}

  removeEvent(){

    this.deleteEventSweetAlert()

  }

  newCalendar(dd){

    this.resetCalendarDialog();

    var dialogCalendar = this.state.dialogCalendar;
    dialogCalendar.date = moment( dd.startStr,'YYYY-MM-DD').format('DD/MM/YYYY');
    this.setState({units:[],lessons:[],editCalendar:"",dialogCalendar:dialogCalendar,titleModalCalendar:this.props.translate['cadastrar_evento'],buttonModalCalendar:this.props.translate['cadastrar']});

  }

  //Para resetar o calendario
  async resetCalendarDialog(){

    var obj = {time:'',date:'',classroom:'',unit:"",lesson:"",color:"",description:""};
    await this.setState({dialogCalendar:obj,modalCalendar:true});

  }

  //Para salvar o calendario
  saveCalendar(event){

    //console.log('salvando');

    event.preventDefault();
    if(this.state.editCalendar === ""){ this.postCalendar(); }else{ this.putCalendar(); }

  }



	render(){
 
    moment.locale(this.props.user.preference.language);

    const handleChange = name => event => {
        var dialogCalendar = this.state.dialogCalendar;
        dialogCalendar[name] = event.target.value;
        this.setState({dialogCalendar:dialogCalendar});
    }

		return(<React.Fragment>
       <div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>
        <style>{'.fc-content{ cursor:pointer; } '}</style>
        {this.state.alert}

        <Container>
          <Card className="card-calendar" style={{marginTop:'60px'}}>
            <CardHeader style={{background:'linear-gradient(-45deg,#384069,#39416b)'}}>
              <Row className="align-items-center py-4">
                <Col lg="6">
                  <h6 className="fullcalendar-title h2 text-white d-inline-block mb-0 mr-1">
                    {

                      (this.calendar.state !== undefined) &&
                      <font> {moment(this.calendar.state.currentDate).format('MMMM')} </font>
                    }
                  </h6>
                </Col>
                <Col className="mt-3 mt-lg-0 text-lg-right" lg="6">
                  <Button className="fullcalendar-btn-prev btn-neutral" color="default" onClick={() => {  this.calendar.next(); this.setState({a:""}); }} size="sm"><i className="fas fa-angle-left" /></Button>
                  <Button className="fullcalendar-btn-next btn-neutral" color="default" onClick={() => { this.calendar.prev(); this.setState({a:""});  }} size="sm"><i className="fas fa-angle-right" /></Button>
                  <Button className="btn-neutral" color="default" data-calendar-view="month" onClick={() => this.calendar.changeView("dayGridMonth")} size="sm" >{this.props.translate['mes']}</Button>
                  <Button className="btn-neutral" color="default" data-calendar-view="basicWeek" onClick={() => this.calendar.changeView("dayGridWeek")} size="sm" >{this.props.translate['semana']}</Button>
                  <Button className="btn-neutral" color="default" data-calendar-view="basicDay" onClick={() => this.calendar.changeView("dayGridDay")} size="sm" >{this.props.translate['dia']}</Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody className="p-0">
              <div className="calendar" ref="calendar" />
            </CardBody>
          </Card>
        </Container>

        <Modal isOpen={this.state.modalCalendar} toggle={() => this.setState({ modalCalendar: false })} className="modal-dialog-centered modal-secondary" >
          <form onSubmit={ (event) => this.saveCalendar(event) } className="new-event--form">
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-default">{this.state.titleModalCalendar}</h6>
            <button aria-label="Close" className="close" data-dismiss="modal" type="button"  onClick={() => this.setState({modalCalendar:false}) }><span aria-hidden={true}>×</span> </button>
          </div>
          <div className="modal-body">
            {
              (this.state.calendarError !== "") &&
              <Alert color="danger" className="animated tada"><strong>Ops!</strong> {this.state.calendarError}</Alert>
            }
            <Row>
              <Col md={6}>
                <label className="form-control-label">{this.props.translate['data']}:</label>
                <FormGroup className={classnames("mb-3",{focused:this.state.focusedNascimento})} >
                  <InputGroup className="input-group-merge input-group-alternative">
                    <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-calendar-grid-58" /></InputGroupText></InputGroupAddon> 
                    <InputMask onChange={handleChange('date')} value={this.state.dialogCalendar.date} className="form-control" mask="99/99/9999" maskChar=" " onFocus={() => this.setState({ focusedNascimento: true }) } onBlur={() => this.setState({ focusedNascimento: false }) }/>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md={6}>
                <label className="form-control-label">{this.props.translate['hora']}:</label>
                <FormGroup className={classnames("mb-3",{focused:this.state.focusedNascimento2})} >
                  <InputGroup className="input-group-merge input-group-alternative">
                    <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-calendar-grid-58" /></InputGroupText></InputGroupAddon> 
                    <InputMask onChange={handleChange('time')} value={this.state.dialogCalendar.time} className="form-control" mask="99:99" maskChar=" " onFocus={() => this.setState({ focusedNascimento2: true }) } onBlur={() => this.setState({ focusedNascimento2: false }) }/>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <label className="form-control-label">{this.props.translate['escolha_a_turma']}:</label>
               <InputGroup className="input-group-merge input-group-alternative">
                <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-badge" /></InputGroupText></InputGroupAddon>
                <Input type="select" value={this.state.dialogCalendar.classroom} className="" onChange={ (event) => { this.changeClassRoom(event.target.value); } }>
                  <option value=""></option>
                  {

                    this.state.classroom.map((value,index) => {

                      return(<option value={value.id} key={value.id}>{value.name}</option>)

                    })

                  }
                </Input>
              </InputGroup>
            </FormGroup>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label">{this.props.translate['escolha_a_unit']}:</label>
                   <InputGroup className="input-group-merge input-group-alternative">
                    <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-badge" /></InputGroupText></InputGroupAddon>
                    <Input id="select_unit" type="select" value={this.state.dialogCalendar.unit} className="" onChange={ (event) => this.changeUnit(event.target.value) }>
                      {

                        this.state.units.map((value,index) => {

                          return(<option value={value.id} key={value.id}>{value.name}</option>)

                        })

                      }
                    </Input>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label">{this.props.translate['escolha_a_lesson']}:</label>
                   <InputGroup className="input-group-merge input-group-alternative">
                    <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-badge" /></InputGroupText></InputGroupAddon>
                    <Input id="select_lesson" onChange={handleChange('lesson')} type="select" className="" value={this.state.dialogCalendar.lesson}>
                      {

                        this.state.lessons.map((value,index) => {

                          return(<option value={value.id} key={value.id}>{value.name}</option>)

                        })

                      }
                    </Input>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            
          	<FormGroup>
                <label className="form-control-label">{this.props.translate['pequena_descricao']}:</label>
                <Input onChange={handleChange('description')} value={this.state.dialogCalendar.description} className="form-control-alternative" placeholder="" rows="3" type="textarea" />
                <Button onClick={ () => this.generateDescription() } className="btn-sm" type="button" style={{marginTop:'5px'}}>Gerar automatico</Button>
            </FormGroup>

            
                  


          	<FormGroup className="mb-0">

                <label className="form-control-label d-block mb-3">{this.props.translate['escolha_a_cor']}:</label>

                <ButtonGroup className="btn-group-toggle btn-group-colors event-tag" data-toggle="buttons" >
                  <Button className={classnames("bg-info", { active: this.state.dialogCalendar.color === "bg-info" })} color="" type="button" onClick={() => { var dialogCalendar = this.state.dialogCalendar; dialogCalendar.color = "bg-info"; this.setState({dialogCalendar:dialogCalendar}); }} />
                  <Button className={classnames("bg-warning", { active: this.state.dialogCalendar.color === "bg-warning" })} color="" type="button" onClick={() => { var dialogCalendar = this.state.dialogCalendar; dialogCalendar.color = "bg-warning"; this.setState({dialogCalendar:dialogCalendar}); }} />
                  <Button className={classnames("bg-danger", { active: this.state.dialogCalendar.color === "bg-danger" })} color="" type="button" onClick={() => { var dialogCalendar = this.state.dialogCalendar; dialogCalendar.color = "bg-danger"; this.setState({dialogCalendar:dialogCalendar}); }} />
                  <Button className={classnames("bg-success", { active: this.state.dialogCalendar.color === "bg-success" })} color="" type="button" onClick={() => { var dialogCalendar = this.state.dialogCalendar; dialogCalendar.color = "bg-success"; this.setState({dialogCalendar:dialogCalendar}); }} />
                  <Button className={classnames("bg-default", { active: this.state.dialogCalendar.color === "bg-default" })} color="" type="button" onClick={() => { var dialogCalendar = this.state.dialogCalendar; dialogCalendar.color = "bg-default"; this.setState({dialogCalendar:dialogCalendar}); }} />
                  <Button className={classnames("bg-primary", { active: this.state.dialogCalendar.color === "bg-primary" })} color="" type="button" onClick={() => { var dialogCalendar = this.state.dialogCalendar; dialogCalendar.color = "bg-primary"; this.setState({dialogCalendar:dialogCalendar}); }} />
                </ButtonGroup>

              </FormGroup>
            
          </div>

          <div className="modal-footer" style={{display:'inherit',marginBottom:'60px',padding:'0px 10px 0px 10px'}}>
            { 

              (this.state.editCalendar !== "" && (this.props.permission.indexOf(28) !== -1) ) && 
              <Button style={{float:'left',color:'red'}} color="link" type="button" onClick={() => this.removeEvent() } >{this.props.translate['remover']}</Button>

            }
            {

              //botao editar
              (this.state.editCalendar !== "" && (this.props.permission.indexOf(27) !== -1) ) && 
              <Button style={{float:'right'}} color="primary" type="submit">{this.state.buttonModalCalendar}</Button>
            
            }
            {

              //botao cadastrar 
              (this.state.editCalendar === "" && (this.props.permission.indexOf(29) !== -1) ) && 
              <Button style={{float:'right'}} color="primary" type="submit">{this.state.buttonModalCalendar}</Button>
            
            }
            <Button style={{float:'right'}} color="link" type="button" onClick={() => this.setState({ modalCalendar: false })} >{this.props.translate['cancelar']}</Button>
          </div>
          
          </form>
        </Modal>
		</React.Fragment>);

	}

}

export default connect(state =>({

  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user,
  unit: state.unit,

}))(Calendar2);